import React, { useEffect, useState } from "react";
import { Button, Nav, NavDropdown } from "react-bootstrap";
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { FormattedMessage } from "react-intl";
import { useDispatch } from "react-redux";

import NavLink from "../../NavLink/NavLink";
import { openHeaderModal } from "../../../actions/siteadmin/modalActions";
import messages from "../../../locale/messages";
import history from "../../../history";
import getStatus from './getUserStatus.graphql'
import useQueryResponse from "../../../lib/hooks/useQueryResponse"
import s from './NavigationAfterLogin.css';


const NavigationAfterLogin = ({ afterDropdown, orderId, handleMenuClose }) => {

    const [location, setLocation] = useState('')
    const dispatch = useDispatch()

    useEffect(() => {
        setLocation(history?.location?.pathname)
    }, [history?.location?.pathname])

    const { data, loading } = useQueryResponse({
        query: getStatus,
        ssr: false,
        fetchPolicy: 'network-only'
    })

    return (

        (afterDropdown ?
            <>
                <NavDropdown.Item as={NavLink} to="/dashboard" className={cx((location === '/dashboard/' || location === '/dashboard') && 'active')}>
                    <FormattedMessage {...messages.dashboard} />
                </NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="/bookings/upcoming" className={cx(location === '/bookings/upcoming' && 'active')}>
                    <FormattedMessage {...messages.myBookings} />
                </NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="/payment-method" className={cx(location === '/payment-method' && 'active')}>
                    <FormattedMessage {...messages.paymentMethodText} />
                </NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="/profile" className={cx(location === '/profile' && 'active')}>
                    <FormattedMessage {...messages.profile} />
                </NavDropdown.Item>
                {orderId && <NavDropdown.Item as={NavLink} to={`/order/${orderId}`} className={cx(location === `/order/${orderId}` && 'active')}>
                    <FormattedMessage {...messages.myCart} />
                </NavDropdown.Item>}
                <NavDropdown.Item to="#">
                    <div onClick={() => dispatch(openHeaderModal('userLogout'))}><FormattedMessage {...messages.logout} /></div>
                </NavDropdown.Item>

            </>
            :
            <Nav className={s.headerNavSubListContainer} onSelect={handleMenuClose}>
                <NavLink to="/dashboard" className={cx(s.headerMenuItem, ((location === '/dashboard/' || location === '/dashboard') && s.activeTabMenu))} >
                    <FormattedMessage {...messages.dashboard} />
                </NavLink>
                <NavLink to="/bookings/upcoming" className={cx(s.headerMenuItem, (location === '/bookings/upcoming' && s.activeTabMenu))} >
                    <FormattedMessage {...messages.myBookings} />
                </NavLink>
                <NavLink to="/payment-method" className={cx(s.headerMenuItem, (location === '/payment-method' && s.activeTabMenu))}>
                    <FormattedMessage {...messages.paymentMethodText} />
                </NavLink>
                <NavLink to="/profile" className={cx(s.headerMenuItem, (location === '/profile' && s.activeTabMenu))}>
                    <FormattedMessage {...messages.profile} />
                </NavLink>
                {orderId && <NavLink to={`/order/${orderId}`} className={cx(s.headerMenuItem, (location === `/order/${orderId}` && s.activeTabMenu))}>
                    <FormattedMessage {...messages.myCart} />
                </NavLink>}
                <NavLink to={''} className={cx(s.headerMenuItem)} onClick={() => dispatch(openHeaderModal('userLogout'))}>
                    <div><FormattedMessage {...messages.logout} /></div>
                </NavLink>
            </Nav>
        )

    )
}
export default withStyles(s)(NavigationAfterLogin)